const $inject = ['moment'];

const lbSequentialTime = function (moment) {

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, ele, attrs, ctrl) {
      const validatorName = 'isDateAfterPreviousDate';
      const timeFormat = attrs.timeFormat;
      let attrWatch;

      attrs.$observe('lbSequentialTime', onEnabledChange);

      function onEnabledChange(newValue) {
        const isEnabled = newValue === 'true';

        if(isEnabled) {
          if(!attrWatch) {
            attrWatch = scope.$watch(watchAttributes, validate, true);
          }
        } else {
          if(angular.isFunction(attrWatch)) {
            attrWatch();
            attrWatch = undefined;
          }

          ctrl.$setValidity(validatorName, true);
        }
      }

      function watchAttributes() {
        return [
          attrs.lbSequentialTimeDate,
          ctrl.$viewValue.value,
          attrs.lbSequentialTimeBeforeDate,
          attrs.lbSequentialTimeBeforeTime
        ]
      }

      function validate(attributes) {
        const date = attributes[0];
        const time = attributes[1];
        const beforeDate = attributes[2];
        const beforeTime = attributes[3];

        const dateTime = moment(`${date}, ${time}`, `ddd Do MMM, YYYY, ${timeFormat}`);
        const beforeDateTime = moment(`${beforeDate}, ${beforeTime}`, `ddd Do MMM, YYYY, ${timeFormat}`);

        ctrl.$setValidity(validatorName, beforeDateTime.isBefore(dateTime));
      }
    }
  };
};

lbSequentialTime.$inject = $inject;

export default lbSequentialTime;


// WEBPACK FOOTER //
// ./src/directives/lbSequentialTime.js